import axios from 'axios'
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedCardsdestinos,
  addingCardsdestinos,
  addingCardsdestinosFailed,
  CardsdestinosAction,
  CardsdestinosActionTypes,
  editedCardsdestinos,
  editingCardsdestinos,
  editingCardsdestinosFailed,
  foundCardsdestinos,
  loadedCardsdestinos,
  loadingCardsdestinos,
  loadingCardsdestinosFailed,
  removedCarddestino,
  removingCarddestino,
  removingCarddestinoFailed,
  searchingCardsdestinos,
  searchingCardsdestinosFailed,
  softRemovedCardsdestinos,
  softRemovingCardsdestinos,
  softRemovingCardsdestinosFailed,
} from '../actions/cardsdestinosActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'
import { API_URL } from '../../config/apiConfig'


const searchCardsdestinosEpic: Epic<CardsdestinosAction, CardsdestinosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsdestinosActionTypes.SEARCH_CARDSDESTINOS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/cardsdestinos/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundCardsdestinos(response.data, action.keep)),
        startWith(searchingCardsdestinos()),
        catchError(() => of(searchingCardsdestinosFailed()))
      )
    })
  )

const loadCardsdestinosEpic: Epic<CardsdestinosAction, CardsdestinosAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(CardsdestinosActionTypes.LOAD_CARDSDESTINOS)),
    switchMap((action) => {
      let url = `${API_URL}/api/cardsdestinos/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedCardsdestinos(response.data)),
        startWith(loadingCardsdestinos()),
        catchError(() => of(loadingCardsdestinosFailed()))
      )
    })
  )
}

const addCardsdestinosEpic: Epic<CardsdestinosAction, CardsdestinosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsdestinosActionTypes.ADD_CARDSDESTINOS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/cardsdestinos/`, data, config)).pipe(
        map((response) => addedCardsdestinos(response.data)),
        startWith(addingCardsdestinos()),
        catchError((err) => of(addingCardsdestinosFailed(err.response)))
      )
    })
  )

const removeCardsdestinosEpic: Epic<CardsdestinosAction, CardsdestinosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsdestinosActionTypes.REMOVE_CARDDESTINO)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardsdestinos/${action.payload._id}`)).pipe(
        map((response) => removedCarddestino()),
        startWith(removingCarddestino()),
        catchError(() => of(removingCarddestinoFailed()))
      )
    )
  )

const softRemoveCardsdestinosEpic: Epic<CardsdestinosAction, CardsdestinosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsdestinosActionTypes.SOFT_REMOVE_CARDSDESTINOS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardsdestinos/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedCardsdestinos(response.data.record)),
        startWith(softRemovingCardsdestinos()),
        catchError((err) => of(softRemovingCardsdestinosFailed(err.response)))
      )
    )
  )

const editCardsdestinosEpic: Epic<CardsdestinosAction, CardsdestinosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsdestinosActionTypes.EDIT_CARDSDESTINOS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/cardsdestinos/${action.payload._id}`, data, config)).pipe(
        map((response) => editedCardsdestinos(response.data)),
        startWith(editingCardsdestinos()),
        catchError((err) => of(editingCardsdestinosFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchCardsdestinosEpic,
  loadCardsdestinosEpic,
  addCardsdestinosEpic,
  removeCardsdestinosEpic,
  softRemoveCardsdestinosEpic,
  editCardsdestinosEpic
)
